import type { DesignLibraryRouter } from "replo-publisher/src/trpc/routers/designLibrary";

import { createTrpcRouterConfig } from "@v2/trpc/config";
import { getNamespacedQueryClient } from "@v2/trpc/trpc";

const {
  router: designLibraryRouter,
  client: designLibraryClient,
  utils: designLibraryUtils,
  options: designLibraryOptions,
} = createTrpcRouterConfig<DesignLibraryRouter>({
  path: "designLibrary",
  queryClient: getNamespacedQueryClient("designLibrary"),
});

export {
  designLibraryClient,
  designLibraryRouter,
  designLibraryUtils,
  designLibraryOptions,
};
